import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CustomerNotes } from "@app/models/customer-notes";
import { CustomerNoteService } from "@app/services/customer-note.service";

@Component({
    selector: "app-customer-note-node",
    templateUrl: "./customer-note-node.component.html",
    styleUrls: ["./customer-note-node.component.css"],
    standalone: false
})
export class CustomerNoteNodeComponent implements OnInit {
  @Input() level: number;
  @Input() customerNotes: Array<CustomerNotes>;
  @Input() selectedCustomerNotes: Array<CustomerNotes>;
  @Output() onAddCustomerNote = new EventEmitter<CustomerNotes>();
  @Output() onDeleteCustomerNote = new EventEmitter<CustomerNotes>();

  constructor(private customerNoteService: CustomerNoteService) {}

  ngOnInit(): void {}

  changeNoteStatus(item, value) {
    if (value.target.checked) {
      this.addCustomerNote(item);
    } else {
      this.deleteCustomerNote(item);
    }
  }

  addCustomerNote(item) {
    this.onAddCustomerNote.emit(item);
  }

  deleteCustomerNote(item) {
    this.onDeleteCustomerNote.emit(item);
  }

  isSelectedCustomerNote(item) {
    var parents = [];
    for (var i = 0; i < this.selectedCustomerNotes.length; i++) {
      var parents = parents.concat(this.customerNoteService.findCustomerNoteParents(this.selectedCustomerNotes[i], this.customerNotes));
    }
    var sParents = new Set(parents);
    if (sParents.has(item)) {
      return true;
    }
    return false;
  }
}
